var depositWithdrawal = /** @class */ (function () {
    function depositWithdrawal() {
    }
    depositWithdrawal.STORE_MODULE_NAME = 'depositWithdrawal';
    return depositWithdrawal;
}());
export { depositWithdrawal };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/depositWithdrawal/lib/depositWithdrawal.cls.ts
// module id = null
// module chunks = 